module.exports = __webpack_public_path__ + "static/media/ac-group.eaaabae5.svg";